<template>
  <span class="gd-type" :class="`gd-type-${type}`">{{ label }}</span>
</template>

<script>
import { getName } from '@/data/billing-guide-types';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      return getName(this.type);
    },
  },
};
</script>
